export default {"src":"/_next/static/media/ic_my_close.a0c06d18.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};